import request from '@/utils/request'

// 纪念馆首页数据
export function GetIndexData(data) {
  return request({
    url: `/Api/Hall/IndexData?id=${data.id}&ww=${data.ww}&wh=${data.wh}`,
    method: 'post'
  })
}

// 纪念馆主页数据
export function GetHomeData(id) {
  return request({
    url: `/Api/Hall/HomeData?id=${id}`,
    method: 'post'
  })
}

// 纪念馆简介数据
export function GetIntroData(id) {
  return request({
    url: `/Api/Hall/Intro?id=${id}`,
    method: 'post'
  })
}

// 纪念馆留言数据
export function GetMsgBoard(data) {
  return request({
    url: `/Api/Hall/MsgBoard?id=${data.id}&pageIndex=${data.pageIndex}&pageSize=${data.pageSize}`,
    method: 'post'
  })
}

// 纪念馆相册数据
export function GetPhotoData(id) {
  return request({
    url: `/Api/Hall/Photo?id=${id}`,
    method: 'post'
  })
}

// 纪念馆文章数据
export function GetArticleData(data) {
  return request({
    url: `/Api/Hall/Article?id=${data.id}&pageIndex=${data.pageIndex}&pageSize=${data.pageSize}`,
    method: 'post'
  })
}

// 纪念馆文章详情
export function GetArticleDetail(id) {
  return request({
    url: `/Api/Hall/ArticleShow?id=${id}`,
    method: 'post'
  })
}

// 纪念馆文章评论列表
export function GetArticleComment(data) {
  return request({
    url: `/Api/Hall/ArticleComment?id=${data.id}&pageIndex=${data.pageIndex}&pageSize=${data.pageSize}`,
    method: 'post'
  })
}

// 添加纪念馆文章评论
export function AddArticleComment(data) {
  return request({
    url: `/Api/Hall/AddArticleComment?id=${data.id}&content=${data.content}`,
    method: 'post'
  })
}

// 纪念馆祭拜记录列表
export function GetRecordList(data) {
  return request({
    url: `/Api/Hall/Record?id=${data.id}&pageIndex=${data.pageIndex}&pageSize=${data.pageSize}`,
    method: 'post'
  })
}

// 祭祀箱分页数据
export function GetSacrifices(data) {
  return request({
    url: `/Api/Hall/Sacrifices?id=${data.id}&pageIndex=${data.pageIndex}&pageSize=${data.pageSize}&mt=${data.mt}`,
    method: 'post'
  })
}

// 祭祀日排行，总排行
export function GetRanking(hallId) {
  return request({
    url: `/Api/Hall/Ranking?hallId=${hallId}`,
    method: 'post'
  })
}

// 获取全部花篮
export function GetFlowers() {
  return request({
    url: '/Api/Hall/FlowerBasket',
    method: 'post'
  })
}

// 添加留言
export function AddHallMsg(data) {
  return request({
    url: `/Api/Hall/AddMsg?hallId=${data.hallId}&flowerBasketId=${data.flowerBasketId}&name=${data.name}&content=${data.content}&imgCode=${data.imgCode}`,
    method: 'post'
  })
}

// 纪念馆祭品分类
export function GetGoodsCategory(id) {
  return request({
    url: `/Api/Hall/GoodsCategory?parentId=${id}`,
    method: 'post'
  })
}

// 纪念馆祭品列表
export function GetGoodList(data) {
  return request({
    url: `/Api/Hall/Goods?categoryId=${data.categoryId}&pageIndex=${data.pageIndex}&pageSize=${data.pageSize}`,
    method: 'post'
  })
}

// 纪念馆扫墓信息
export function GetSweepInfo(data) {
  return request({
    url: `/Api/Hall/TombSweep/Info?categoryId=${data.categoryId}&hallId=${data.hallId}`,
    method: 'post'
  })
}

// 纪念馆献歌获取歌曲分类
export function GetMusicCategory() {
  return request({
    url: '/Api/Hall/Music/Category',
    method: 'post'
  })
}

// 纪念馆献歌获取歌曲列表
export function GetMusicList(data) {
  return request({
    url: `/Api/Hall/Music/List?categoryId=${data.categoryId}&pageIndex=${data.pageIndex}&pageSize=${data.pageSize}`,
    method: 'post'
  })
}

// 纪念馆献歌接口
export function SubmitMusic(data) {
  return request({
    url: `/Api/Hall/Music/Sing?hallId=${data.hallId}&musicId=${data.musicId}&name=${data.name}&content=${data.content}&imgCode=${data.imgCode}`,
    method: 'post'
  })
}

// 保存祭品
export function SaveSacrifice(data) {
  return request({
    url: '/Api/Hall/Sacrifices/Save',
    method: 'post',
    data: data
  })
}

// 验证当前登录人是否有当前纪念馆移动祭品的权限
export function CheckPower(hallId) {
  return request({
    url: `/Api/Hall/VerifyManage?hallId=${hallId}`,
    method: 'post'

  })
}

// 移动祭品
export function MoveSacrifice(data) {
  return request({
    url: '/Api/Hall/Sacrifices/Move',
    method: 'post',
    data: data
  })
}

// 隐藏祭品
export function HideSacrifice(id) {
  return request({
    url: `/Api/Hall/Sacrifices/Hide?id=${id}`,
    method: 'post'
  })
}

// 删除祭品
export function DeleteSacrifice(id) {
  return request({
    url: `/Api/Hall/Sacrifices/Delete?id=${id}`,
    method: 'post'
  })
}

// 显示祭品
export function ShowSacrifice(id) {
  return request({
    url: `/Api/Hall/Sacrifices/Show?id=${id}`,
    method: 'post'

  })
}

// 设置纪念馆实景墓地图片
export function SetGraveUpload(data) {
  return request({
    url: `/Api/Hall/Realscene?hallId=${data.hallId}&imgUrl=${data.imgUrl}`,
    method: 'post'
  })
}

// 关注/取消关注纪念馆
export function HallFollow(hallId) {
  return request({
    url: `/Api/Personal/Hall/Follow?hallId=${hallId}`,
    method: 'post'
  })
}

// 申请纪念馆亲友
export function ApplyRelative(hallId) {
  return request({
    url: `/Api/Hall/Relative?hallId=${hallId}`,
    method: 'post'
  })
}

// 获取对应相册下的图片列表
export function GetPhotoImages(id) {
  return request({
    url: `/Api/Hall/Photo/Image?id=${id}`,
    method: 'post'
  })
}

// 代理祭祀发送验证码
export function SendProxyCode(phone) {
  return request({
    url: `/Api/Hall/SendProxyCode?phone=${phone}`,
    method: 'post'
  })
}

// 代理祭祀
export function Proxy(data) {
  return request({
    url: '/Api/Hall/Proxy',
    data: data,
    method: 'post'
  })
}
